import { ftpAPI } from '@/api';
import { ErrorService } from '@/services/error-service.js';

/**************** STATE *******************/
const state = {
  ftpChoicesLoading: false,
  ftpChoices: [],

  currentFTP: null
};

/**************** GETTERS *******************/
const getters = {};

/**************** MUTATIONS *******************/
const mutations = {
  

  SET_CURRENT_FTP: (state, payload) => {
    state.currentFTP = payload;
  }
};

/**************** ACTIONS *******************/
const actions = {

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};